import Vue from 'vue';
// import ALARM_BASIC from '@/assets/css/alarm_basic.mp3';
import ALARM_BELL from '@/assets/css/alarm_bell.mp3';
import ALARM_COLDWIND from '@/assets/css/alarm_coldwind.mp3';
import ALARM_CRUISESHIP from '@/assets/css/alarm_cruiseship.mp3';
import ALARM_SINGLERING from '@/assets/css/alarm_single_ring.mp3';
import Logger from '@/js/logger';

// import ALARM_WORLDSOUND from '@/assets/css/alarm_world_sounds.mp3';
// import { base64Url2Hex, hexToBase64Url } from '@/js/dataConversion';

export const BAUD_RATE = [
  { value: 1200, label: 1200 },
  { value: 2400, label: 2400 },
  { value: 4800, label: 4800 },
  { value: 9600, label: 9600 },
  { value: 19200, label: 19200 },
  { value: 38400, label: 38400 },
  { value: 57600, label: 57600 },
  { value: 115200, label: 115200 },
  { value: 230400, label: 230400 },
];

export const PARITY = [
  { value: 0, label: 'NONE' },
  { value: 1, label: 'EVEN' },
  { value: 2, label: 'ODD' },
  { value: 3, label: 'MARK' },
  { value: 4, label: 'SPACE' },
];

export const FC_MAP = {
  0: 1,
  1: 2,
  3: 4,
  4: 3,
};

export const DATA_BIT = [
  { value: 8, label: 8 },
  { value: 7, label: 7 },
];

export const STOP_BIT = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
];

export const DATATYPE = {
  BIT: 1,
  INT8: 2,
  INT16: 'INT16',
  INT32: 'INT32',
  UINT8: 5,
  UINT16: 'UINT16',
  UINT32: 'UINT32',
  FLOAT: 'FLOAT',
  DOUBLE: 'DOUBLE',
};

export function getByteCountFromDataType(dataType) {
  switch (dataType) {
    case DATATYPE.BIT:
    case DATATYPE.INT8:
    case DATATYPE.UINT8:
      return 1;
    case DATATYPE.INT16:
    case DATATYPE.UINT16:
    default:
      return 2;
    case DATATYPE.INT32:
    case DATATYPE.UINT32:
    case DATATYPE.FLOAT:
      return 4;
    case DATATYPE.DOUBLE:
      return 8;
  }
}

export const RAW_DATA_TYPE = [
  // { value: DATATYPE.BIT, label: 'BIT' },
  // { value: DATATYPE.INT8, label: 'INT8' },
  { value: DATATYPE.INT16, label: 'Short' },
  { value: DATATYPE.UINT16, label: 'Unsigned Short' },
  { value: DATATYPE.INT32, label: 'Integer' },
  //  { value: 3, label: 'INT64' },
  // { value: DATATYPE.UINT8, label: 'UINT8' },
  { value: DATATYPE.UINT32, label: 'Unsigned Integer' },
  // { value: 7, label: 'UINT64' },
  //  { value: 8, label: 'BCD8' },
  //  { value: 9, label: 'BCD16' },
  // { value: 10, label: 'BCD32' },
  // { value: 11, label: 'BCD64' },
  // { value: 12, label: 'UBCD8' },
  //  { value: 13, label: 'UBCD16' },
  //  { value: 14, label: 'UBCD32' },
  //  { value: 15, label: 'UBCD64' },
  { value: DATATYPE.FLOAT, label: 'Float' },
  { value: DATATYPE.DOUBLE, label: 'Double' },
  // { value: 18, label: 'BIT1' },
  // { value: 19, label: 'BIT2' },
  //  { value: 20, label: 'BIT3' },
  // { value: 21, label: 'BIT4' },
];

export const ENG_DATA_TYPE = [
  { value: 0, label: 'INT8' },
  { value: 1, label: 'INT16' },
  { value: 2, label: 'INT32' },
  { value: 3, label: 'INT64' },
  { value: 4, label: 'UINT8' },
  { value: 5, label: 'UINT16' },
  { value: 6, label: 'UINT32' },
  { value: 16, label: 'FLOAT' },
  // { value: 17, label: 'DOUBLE' },
];

export const CVS_RULE = {
  NA: 1,
  RATIO_BIAS: 2,
  PROP: 3,
  PROP_OFFSET: 4,
};

export const CONVERSION_RULE = [
  { value: CVS_RULE.NA, label: 'N/A' },
  { value: CVS_RULE.RATIO_BIAS, label: 'Ratio/Bias' },
  { value: CVS_RULE.PROP, label: 'Proportion' },
  { value: CVS_RULE.PROP_OFFSET, label: 'Proportion/Offset' },
];

export const ENDIAN_MODE = {
  BIG_ENDIAN: 'BE',
  LITTLE_ENDIAN: 'LE',
  BIG_ENDIAN_BYTESWAP: 'BES',
  LITTLE_ENDIAN_BYTESWAP: 'LES',
};

export function isBigEndianMode(mode) {
  return mode.startsWith('BE');
}

export function isByteSwap(mode) {
  return mode.endsWith('ES');
}

export const BYTE_ORDER = [
  { value: ENDIAN_MODE.BIG_ENDIAN, label: 'Big Endian' },
  { value: ENDIAN_MODE.BIG_ENDIAN_BYTESWAP, label: 'Big Endian Byte Swap' },
  { value: ENDIAN_MODE.LITTLE_ENDIAN, label: 'Little Endian' },
  {
    value: ENDIAN_MODE.LITTLE_ENDIAN_BYTESWAP,
    label: 'Little Endian Byte Swap',
  },
];

export const REQ_FUNC = {
  FC01: 1,
  FC02: 2,
  FC03: 3,
  FC04: 4,
  FC05: 5,
  FC06: 6,
  FC07: 7,
  FC15: 15,
  FC16: 16,
};

export const FUNC_CODE = [
  { value: REQ_FUNC.FC01, label: '01: Read Coils' },
  { value: REQ_FUNC.FC02, label: '02: Read Discrete Inputs' },
  { value: REQ_FUNC.FC03, label: '03: Read Holding Registers' },
  { value: REQ_FUNC.FC04, label: '04: Read Input Registers' },
  // { value: REQ_FUNC.FC05, label: '05: Write Single Coil' },
  // { value: REQ_FUNC.FC06, label: '06: Write Single Register' },
  // { value: REQ_FUNC.FC07, label: '07: Read Exception Status' },
  // { value: REQ_FUNC.FC15, label: '15: Write Multiple Coils' },
  // { value: REQ_FUNC.FC16, label: '16: Write Multiple Registers' },
];

export const MODBUS_MODE = [
  { value: 0, label: 'Modbus RTU' },
  { value: 1, label: 'Modbus ASCII' },
];

export const RESULT_CONFIG_FAILED = 1;
export const RESULT_SETTING_FAILED = 2;
export const RESULT_PKGWARE_FAILED = 3;
export const RESULT_CONFIG_UPDATED = 4;
export const RESULT_SCHEDULE_UPDATED = 5;
export const RESULT_PKGWARE_UPDATED = 6;
export const RESULT_PKGWARE_UNKNOWN = 7;
export const RESULT_SETTING_UNKNOWN = 8;

export const STATE_CONFIG_START = 'CONFIG_STARTED';
export const STATE_CONFIG_END = 'CONFIG_ENDED';
export const MAX_MQTT_SAMPLE = 1600;

export const STATE_PKGWARE_DOWNLOADING = 'PKGWARE_DOWNLOADING';
export const STATE_PKGWARE_UNLOADED = 'PKGWARE_DOWNLOAD_FAILED';
export const STATE_PKGWARE_UPDATING = 'PKGWARE_UPDATING';
export const STATE_PKGWARE_SUCCESS = 'PKGWARE_UPDATE_SUCCEEDED';
export const STATE_PKGWARE_FAILED = 'PKGWARE_UPDATE_FAILED';

export const SIG_5561_REF = {
  E01: 'N/A',
  E02: 'N/A',
  E03: 'N/C',
  E04: 'N/A',
};

export const MODBUS_ERR = {
  E0x0B: 'N/C', // 'Timeout',
  E0x01: 'N/A', // 'Invalid Function',
  E0x02: 'N/A', // 'Invalid Address',
  E0x03: 'N/A', // 'Invalid Value',
  E0x06: 'N/A', // 'Slave Busy',
};

export const SOUNDLIST = [
  { label: 'Bell', file: ALARM_BELL, value: 0 },
  { label: 'Cold Wind', file: ALARM_COLDWIND, value: 1 },
  { label: 'Cruise Ship', file: ALARM_CRUISESHIP, value: 2 },
  { label: 'Single Ring', file: ALARM_SINGLERING, value: 3 }, //,
  // { label: 'World Sound', file: ALARM_WORLDSOUND, value: 4 }
];

export const COLOR_LIST = process.env.COLOR_LIST;

export const SOLLAE_BASE_URL = process.env.SOLLAE_API_URL;
// location.protocol + '//' + location.hostname + '/';

const ERR_INVALID_JSON = 'JSON_FORMAT_INVALID';

// MQTT Error Code
export const ERR_MQTT_DISCONNECTED = 'MQTT_DISCONNECTED';
export const ERR_DEREGISTER_FAILED = 'DEREGISTER_FAILED';
export const ERR_SETTING_FAILED = 'SETTING_UPDATE_FAILED';
export const ERR_OPERATION_FAILED = 'DEVICE_OPERATION_FAILED';
export const ERR_CLIENT_NOTFOUND = 'MQTT_CLIENT_NOTFOUND';
export const ERR_PUBLISH_FAILED = 'MQTT_PUBLISH_FAILED';

// REST API Error Code
export const ERR_REQ_TIMEOUT = 'REQUEST_TIMEOUT';
export const ERR_RES_INVALID = 'RESPONSE_INVALID';
export const ERR_NETWORK_FAILED = 'NETWORK_FAILURE';
export const ERR_RES_UNEXPECTED = 'RESPONSE_UNEXPECTED';

export const SOUND_REPEAT = 1;
export const SOUND_PERMISSION = 2;
export const DASHBOARD_CENTER = 5;
export const CONTROL_MSG = 9;
export const ALARM_MSG = 10;
export const COUNTER_MSG = 11;
export const TOAST_DISABLE_NOTI = 17;
export const TOAST_CLOSE_WARNING = 18;
export const TOAST_CLOSE_ERROR = 19;

export const MIN_INT32 = 0;
export const MIN_PINT32 = 1;
export const MAX_INT32 = 2147483647;
export const MAX_PHPOC_DELAY = process.env.MAX_PHPOC_DELAY;
export const MAX_INTERACTION = process.env.MAX_INTERACTION;
export const MIN_SLAVE_ADDR = 0;
export const MAX_SLAVE_ADDR = 247;
export const MIN_MBUS_ADDR = 0;
export const MAX_MBUS_ADDR = 65535;
export const MAX_QUERIES = process.env.MAX_QUERIES;
export const MIN_DEC_PLACE = 0;
export const MAX_DEC_PLACE = 6;
export const MIN_INTERFRAME_GAP = 0;
export const MAX_INTERFRAME_GAP = 5000;

const WGT_AI_TEXT = 0x00;
const WGT_AI_GAUGE = 0x01;
const WGT_AI_CHART = 0x02;
const WGT_AI_THERMO = 0x03;
const WGT_AI_DROPLET = 0x04;
const WGT_AI_HBAR = 0x05;
const WGT_AI_VBAR = 0x06;
const WGT_AI_CBAR = 0x07;
const WGT_AI_7SEG = 0x08;

const WGT_DI_DLED = 0x10;
const WGT_DI_CHART = 0x11;
const WGT_DI_COUNTER = 0x12;

const WGT_DO_PLED = 0x20;
const WGT_DO_SCHL = 0x21;
const WGT_DO_CHART = 0x22;

const DESKTOP_THEME_BYTEPOS = process.env.DESKTOP_THEME_BYTEPOS;
const MOBILE_THEME_BYTEPOS = process.env.MOBILE_THEME_BYTEPOS;

const TEMPO_CELCIUS = process.env.TEMPO_CELCIUS;
const SIG_5561_DEC_PLACE = process.env.SIG_5561_DEC_PLACE;
export const WGT_LIST = {
  WGT_AI_TEXT,
  WGT_AI_GAUGE,
  WGT_AI_CHART,
  WGT_AI_THERMO,
  WGT_AI_DROPLET,
  WGT_AI_HBAR,
  WGT_AI_VBAR,
  WGT_AI_CBAR,
  WGT_AI_7SEG,

  WGT_DI_DLED,
  WGT_DI_CHART,
  WGT_DI_COUNTER,

  WGT_DO_PLED,
  WGT_DO_SCHL,
  WGT_DO_CHART,
};

const CMD_OUTPUT_LOW = 0;
const CMD_OUTPUT_HIGH = 1;
const CMD_OUTPUT_TOGGLE = 2;
const CMD_OUTPUT_PULSE = 4;

export const COMMAND_LIST = {
  CMD_OUTPUT_HIGH,
  CMD_OUTPUT_LOW,
  CMD_OUTPUT_TOGGLE,
  CMD_OUTPUT_PULSE,
};

const MIN_ADC = 0;
const MAX_ADC = 4095;
const MAX_TEMPERATURE = process.env.MAX_TEMPERATURE;

export const TIMEDIFF_TOLERANCE = process.env.TIMEDIFF_TOLERANCE;

export const MAX_PORTS_PER_LINE = 4;
export const DIGITAL_OUTPUT = 'DO';
export const DIGITAL_INPUT = 'DI';
export const ANALOG_INPUT = 'AI';
export const TEMPERATURE = 'TS';

export const STUDIO_TABS = {
  DESIGN_TAB: 0,
  TAGSETTING_TAB: 1,
  INTERACTION_TAB: 2,
};

const MONTH_LIST = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const MOUSE_ACTION_LIST = Object.freeze({
  ACTION_NONE: 0,
  ACTION_MOVE: 1,
  ACTION_RS_TOPLEFT: 2,
  ACTION_RS_TOPRIGHT: 3,
  ACTION_RS_BOTRIGHT: 4,
  ACTION_RS_BOTLEFT: 5,
  ACTION_RS_TOP: 6,
  ACTION_RS_RIGHT: 7,
  ACTION_RS_BOT: 8,
  ACTION_RS_LEFT: 9,
  ACTION_ROTATE: 10,
  ACTION_GROUP: 11,
});

export const SOLLAE_LOCAL_STORE = Object.freeze({
  S_SORTBY: 'S_SORTBY',
  S_DISABLED_SOUND: 'S_DISABLE_SOUND',
  S_STUDIO_PAGE: 'S_STUDIO_PAGE',
});

export const SOLLAE_MODEL = Object.freeze({
  SIG_5431: 'SIG-5431',
  SIG_5441: 'SIG-5441',
  SIG_5451: 'SIG-5451',
  SIG_5601: 'SIG-5601',
  SIG_5561: 'SIG-5561',
  SMG_5511: 'SMG-5511',
  SMG_5521: 'SMG-5521',
});

export const SORT_BY = [
  { label: 'COMMON.str24', value: 0 },
  { label: 'COMMON.str25', value: 1 },
  { label: 'COMMON.str26', value: 2 },
  { label: 'COMMON.str27', value: 3 },
  { label: 'COMMON.str07', value: 4 },
  { label: 'COMMON.str08', value: 5 },
];

export const SERVICE_TYPE = [
  { label: 'COMMON.str45', value: 0 },
  { label: 'COMMON.str46', value: 1 },
];

export const LANGLIST = [
  { label: 'English', value: 'en' },
  { label: '한국어', value: 'ko' },
];
export const THEMELIST = [
  { label: 'COMMON.str31', value: 0 },
  { label: 'COMMON.str32', value: 1 },
  { label: 'COMMON.str43', value: 3 },
  // { label: 'COMMON.str42', value: 2 }
];

export const TIMEZONELIST = [
  { label: '(UTC-12:00) International Day Line West', value: 720 },
  { label: '(UTC-11:00) Coordinated Universal Time-11', value: 660 },
  { label: '(UTC-10:00) Aleutian Islands, Hawaii', value: 600 },
  { label: '(UTC-09:30) Marquesas Islands', value: 570 },
  { label: '(UTC-09:00) Alaska', value: 540 },
  { label: '(UTC-08:00) Baja California, Pacific Time (US & CAN)', value: 480 },
  {
    label: '(UTC-07:00) Arizona, Chihuahua, Mountain Time (US & CAN)',
    value: 420,
  },
  {
    label:
      '(UTC-06:00) Central America, Central Time (US & CAN), Mexico City, Saskatchewan',
    value: 360,
  },
  {
    label: '(UTC-05:00) Bogota, Lima, Quito, Eastern Time (US & CAN), Havana',
    value: 300,
  },
  {
    label:
      '(UTC-04:00) Atlantic Time (CAN), Caracas, Cuiaba, Georgetown, La Paz, Santiago',
    value: 240,
  },
  { label: '(UTC-03:30) New Foundland', value: 210 },
  {
    label: '(UTC-03:00) Brasilia, Cayenne, Buenos Aires, Greenland, Montevideo',
    value: 180,
  },
  { label: '(UTC-02:00) Coordinated Universal Time-02', value: 120 },
  { label: '(UTC-01:00) Azores, Cabo Verde Island', value: 60 },
  {
    label:
      '(UTC+00:00) Coordinated Universal Time, Dublin, Edinburgh, Lisbon, London, Reykjavik',
    value: 0,
  },
  {
    label:
      '(UTC+01:00) Amsterdam, Berlin, Rome, Brussels, Madrid, Prague, Paris, Stockholm, Vienna, Warsaw',
    value: -60,
  },
  {
    label:
      '(UTC+02:00) Athens, Bucharest, Beirut, Cairo, Helsinki, Jerusalem, Kaliningrad',
    value: -120,
  },
  {
    label:
      '(UTC+03:00) Baghdad, Istanbul, Kuwait, Riyadh, St. Peterburg, Moscow',
    value: -180,
  },
  { label: '(UTC+03:30) Tehran', value: -210 },
  {
    label: '(UTC+04:00) Abu Dhabi, Muscat, Ulyanovsk, Tbilisi, Volgograd',
    value: -240,
  },
  { label: '(UTC+04:30) Kabul', value: -270 },
  {
    label: '(UTC+05:00) Ashgabat, Tashkent, Ekaterinburg, Islamabad',
    value: -300,
  },
  { label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Dehli', value: -330 },
  { label: '(UTC+05:45) Kathmandu', value: -345 },
  { label: '(UTC+06:00) Astana, Dhaka, Omsk', value: -360 },
  { label: '(UTC+06:30) Yangon', value: -390 },
  {
    label: '(UTC+07:00) Bangkok, Hanoi, Jakarta, Novosibirsk, Tomsk',
    value: -420,
  },
  {
    label:
      '(UTC+08:00) Beijing, HongKong, Irkutsk, Kuala Lumpur, Singapore, Perth, Taipei',
    value: -480,
  },
  { label: '(UTC+08:45) Eucla', value: -525 },
  { label: '(UTC+09:00) Seoul (서울), Tokyo, Yakutsk', value: -540 },
  { label: '(UTC+09:30) Adelaide, Darwin', value: -570 },
  {
    label: '(UTC+10:00) Canberra, Melbourne, Sydney, Guam, Vladivostok',
    value: -600,
  },
  { label: '(UTC+10:30) Lord Howe Island', value: -630 },
  {
    label: '(UTC+11:00) Magadan, Norfolk Island, Solomon Island, New Caledonia',
    value: -660,
  },
  { label: '(UTC+12:00) Auckland, Wellington, Fiji', value: -720 },
  { label: '(UTC+12:45) Chatham Islands', value: -765 },
  { label: "(UTC+13:00) Nuku'alofa, Samoa", value: -780 },
  { label: '(UTC+14:00) Kiritimati Island', value: -840 },
];

export const STS = Object.freeze({
  ADD: 'ADD',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
});

export const FONT_LIST = process.env.FONT_LIST;

export const MOUSE_EVENT_SEND_DO_CMD_CODE = 8;

export const MOUSE_EVENT_NAVIGAT_PAGE_CODE = 4;

export const EventBus = new Vue();

export function mapModbusPortType(port_type, req_func, hmi_addr) {
  if (port_type === 'MB') {
    switch (req_func) {
      case REQ_FUNC.FC01:
      case REQ_FUNC.FC05:
        return DIGITAL_OUTPUT;
      case REQ_FUNC.FC02:
        return DIGITAL_INPUT;
      default:
        return ANALOG_INPUT;
    }
  } else {
    const functionCode = hmi_addr.substring(0, 1);
    switch (functionCode) {
      case '0':
        return DIGITAL_OUTPUT;
      case '1':
        return DIGITAL_INPUT;
      default:
        return ANALOG_INPUT;
    }
  }
}

export function map_limit(x, in_min, in_max, out_min, out_max) {
  return x < in_min
    ? out_min
    : x > in_max
    ? out_max
    : ((x - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
}

export function getStorageItem(itemKey) {
  if (itemKey) {
    return localStorage.getItem(location.hostname + itemKey);
  }
}

export function setStorageItem(itemKey, itemValue) {
  if (itemKey) {
    return localStorage.setItem(location.hostname + itemKey, itemValue);
  }
}

export function removeStorageItem(itemKey) {
  if (itemKey) {
    return localStorage.removeItem(location.hostname + itemKey);
  }
}

export function map_adc(x, out_min, out_max, tempo_mode) {
  if (tempo_mode) return x;
  return x < MIN_ADC
    ? out_min
    : x > MAX_ADC
    ? out_max
    : ((x - MIN_ADC) * (out_max - out_min)) / (MAX_ADC - MIN_ADC) + out_min;
}

export function setUnitFontSize(fontSize) {
  return Math.ceil(fontSize) + 'px ' + process.env.UNIT_FONT;
}

export function setDefaultFontSize(fontSize) {
  return Math.ceil(fontSize) + 'px ' + process.env.DEFAULT_FONT;
}

export function setDigitFontSize(fontSize) {
  return Math.ceil(fontSize) + 'px ' + process.env.DIGIT_FONT;
}

export function getPrintedNumber(val, format) {
  if (SIG_5561_REF[val]) return SIG_5561_REF[val];
  if (MODBUS_ERR[val]) return MODBUS_ERR[val];
  return isNaN(format)
    ? val
      ? process.env.STATE_HIGH
      : process.env.STATE_LOW
    : isNaN(val)
    ? ''
    : roundedValue(val, format, true);
}

export function isStr(str) {
  return typeof str === 'string';
}

export function isFunction(f) {
  return typeof f === 'function';
}

function getZerosString(str) {
  const len = (str + '').length;
  let txt = ' ';
  for (let i = 0; i < len; i++) {
    txt += '0';
  }
  return txt;
}

export function updateCtxFontSize(ctx, currSize, value, maxLength, cb) {
  ctx.font = currSize;
  cb = cb || setDefaultFontSize;
  var textSize = ctx.measureText(getZerosString(value)).width;
  while (textSize > maxLength) {
    var fontSize = Math.round(parseFloat(ctx.font) * 0.8);
    ctx.font = cb(fontSize);
    textSize = ctx.measureText(getZerosString(value)).width;
  }
}

export function getBit(register, position) {
  return (register & (1 << position)) !== 0;
}

export function setBit(register, position) {
  return register ^ (1 << position);
}

export function getLocalItem(key) {
  return getBoolean(localStorage.getItem(key));
}

export function setLocalItem(key, value) {
  if (value == null) localStorage.removeItem(key);
  else localStorage.setItem(key, value);
}

export function hasDuplicatedElements(array) {
  var object = {};
  array.forEach((item) => {
    if (!object[item]) {
      object[item] = 0;
    }
    object[item] += 1;
  });

  for (const prop in object) {
    if (object[prop] >= 2) {
      return prop;
    }
  }
}

export function scheduleToString(sch) {
  return (
    sch.time_hours +
    ' ' +
    sch.time_minutes +
    ' ' +
    sch.time_dayofweek.sort().toString()
  );
}

export function eventToString(evt) {
  return evt.event_condition + ' ' + evt.event_value;
}

export function isInteger(value) {
  return (
    /^\d+$/.test(value) &&
    compareStringNumber(value, MIN_INT32.toString()) >= 0 &&
    compareStringNumber(value, MAX_INT32.toString()) <= 0
  );
}

export function getCurrentTimeString() {
  const date = new Date();
  return (
    getTwoDigitString(date.getHours()) +
    ':' +
    getTwoDigitString(date.getMinutes()) +
    ':' +
    getTwoDigitString(date.getSeconds()) +
    '.' +
    getTwoDigitString(Math.round(date.getMilliseconds() / 100))
  );
}

export function generateResetCommand(uid, port, counterValue) {
  return { uid, data: { [port]: '6 ' + counterValue } };
}

export function generateControlCommand(uid, port, command, isRaw) {
  return { uid, data: isRaw ? command : { [port]: command } };
}

function compareStringNumber(a, b) {
  // return -1 if a < b, 0 if a = b, 1 if a > b
  var parsedA = a.toString().replace(/^0+/, '');
  var parsedB = b.toString().replace(/^0+/, '');
  if (parsedA.length !== parsedB.length) {
    return parsedA.length > parsedB.length ? 1 : -1;
  } else {
    for (var i = 0; i < parsedA.length; i++) {
      if (parsedA[i] !== parsedB[i]) {
        return parsedA[i] > parsedB[i] ? 1 : -1;
      }
    }
  }
  return 0;
}

export function generateAddViewRequest({ view_name, view_config }) {
  return {
    data: {
      view_name,
      view_config: JSON.stringify(view_config),
    },
  };
}

function generateUpdateViewRequest({ view_id, view_name, view_config }) {
  return {
    view_id,
    data: {
      view_name,
      view_config: JSON.stringify(view_config),
    },
  };
}

export function generateDeleteViewRequest({ view_id }) {
  return {
    view_id,
  };
}

export function generateAddPageRequest({ view_id, page_config }) {
  return {
    view_id,
    data: {
      page_config: JSON.stringify(page_config),
    },
  };
}

function generateUpdatePageRequest({ view_id, page_id, page_config }) {
  return {
    view_id,
    page_id,
    data: {
      page_config: JSON.stringify(page_config),
    },
  };
}

export function generateDeletePageRequest({ view_id, page_id }) {
  return {
    view_id,
    page_id,
  };
}

export function generateAddItemRequest({
  view_id,
  page_id,
  item_config,
  port_id,
}) {
  return {
    view_id,
    page_id,
    data: {
      item_config: JSON.stringify(item_config),
      port_id,
    },
  };
}

export function compareObjects(obj1, obj2) {
  // Sort properties of each object alphabetically
  const sortedObj1 = sortObject(obj1);
  const sortedObj2 = sortObject(obj2);

  // Stringify sorted objects
  const str1 = JSON.stringify(sortedObj1);
  const str2 = JSON.stringify(sortedObj2);

  // Compare the resulting strings for equality
  return str1 === str2;
}

function sortObject(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(sortObject);
  }

  return Object.keys(obj)
    .sort()
    .reduce((sorted, key) => {
      sorted[key] = sortObject(obj[key]);
      return sorted;
    }, {});
}

function generateUpdateItemRequest({
  view_id,
  page_id,
  item_id,
  item_config,
  port_id,
}) {
  return {
    view_id,
    page_id,
    item_id,
    data: {
      item_config: JSON.stringify(item_config),
      port_id,
    },
  };
}

export function generateDeleteItemRequest({ view_id, page_id, item_id }) {
  return {
    view_id,
    page_id,
    item_id,
  };
}

export function getTargetByClass(element, className) {
  const MAX_TRIES = 5;
  let tries = 0;
  let parent = element;

  while (tries < MAX_TRIES && parent) {
    if (typeof parent.className === 'string') {
      if (parent.className.indexOf(className) !== -1) return true;
    } else if (typeof parent.className === 'object') {
      if (parent.className.baseVal.indexOf(className) !== -1) return true;
    }
    tries++;
    parent = parent.parentNode;
  }
  return false;
}

export function getParentAttribute(element, attr) {
  const MAX_TRIES = 5;
  let tries = 0;
  let parent = element.ownerSVGElement
    ? element.ownerSVGElement.parentNode
    : element;

  while (tries < MAX_TRIES && parent) {
    const attrValue = parent.getAttribute(attr);
    if (attrValue) return attrValue;
    tries++;
    parent = parent.parentNode;
  }
  return null;
}

export function generateViewRequests(viewPayload) {
  const ret = {
    ADD_VIEW: [],
    DELETE_VIEW: [],
    UPDATE_VIEW: [],
    ADD_PAGE: [],
    DELETE_PAGE: [],
    UPDATE_PAGE: [],
    ADD_ITEM: [],
    DELETE_ITEM: [],
    UPDATE_ITEM: [],
    length: 0,
  };
  switch (viewPayload.status) {
    case STS.ADD:
      ret.length++;
      ret.ADD_VIEW.push(generateAddViewRequest(viewPayload));
      return;
    case STS.DELETE:
      ret.length++;
      ret.DELETE_VIEW.push(generateDeleteViewRequest(viewPayload));
      return;
    case STS.UPDATE:
      ret.length++;
      ret.UPDATE_VIEW.push(generateUpdateViewRequest(viewPayload));
      break;
  }

  if (Array.isArray(viewPayload.pages)) {
    viewPayload.pages.forEach((pagePayload) => {
      switch (pagePayload.status) {
        case STS.ADD:
          if (pagePayload.page_config) {
            ret.length++;
            ret.ADD_PAGE.push(
              generateAddPageRequest({
                ...pagePayload,
                view_id: viewPayload.view_id,
              })
            );
          }
          return;
        case STS.DELETE:
          ret.length++;
          ret.DELETE_PAGE.push(
            generateDeletePageRequest({
              ...pagePayload,
              view_id: viewPayload.view_id,
            })
          );
          return;
        case STS.UPDATE:
          if (pagePayload.page_config) {
            ret.length++;
            ret.UPDATE_PAGE.push(
              generateUpdatePageRequest({
                ...pagePayload,
                view_id: viewPayload.view_id,
              })
            );
          }
          break;
      }
      if (Array.isArray(pagePayload.items)) {
        pagePayload.items.forEach((itemPayload) => {
          switch (itemPayload.status) {
            case STS.ADD:
              if (itemPayload.item_config) {
                ret.length++;
                ret.ADD_ITEM.push(
                  generateAddItemRequest({
                    ...itemPayload,
                    view_id: viewPayload.view_id,
                    page_id: pagePayload.page_id,
                  })
                );
              }
              break;
            case STS.DELETE:
              ret.length++;
              ret.DELETE_ITEM.push(
                generateDeleteItemRequest({
                  ...itemPayload,
                  view_id: viewPayload.view_id,
                  page_id: pagePayload.page_id,
                })
              );
              break;
            case STS.UPDATE:
              if (itemPayload.item_config) {
                ret.length++;
                ret.UPDATE_ITEM.push(
                  generateUpdateItemRequest({
                    ...itemPayload,
                    view_id: viewPayload.view_id,
                    page_id: pagePayload.page_id,
                  })
                );
              }
              break;
          }
        });
      }
    });
  }
  return ret;
}

export function cloneObject(src) {
  if (!src || typeof src !== 'object') return src;
  return JSON.parse(JSON.stringify(src));
}

export function clonePortsData(pData) {
  const portData = cloneObject(pData);
  const isModbusDevice = isModbusGateway(portData.dev_model);

  return {
    dev_id: portData.dev_id,
    dev_client_id: portData.dev_client_id,
    dev_model: portData.dev_model,
    dev_desc: portData.dev_desc,
    dev_pkg: portData.dev_pkg,
    mac_addr: portData.mac_addr,
    add_date: portData.add_date,
    dev_nickname: portData.dev_nickname,
    ...(isModbusDevice && {
      modbus_mode: portData.modbus_mode,
      modbus_timeout: portData.modbus_timeout,
      modbus_interframe_gap: portData.modbus_interframe_gap,
      max_query: portData.max_query,
      serial_baudrate: portData.serial_baudrate,
      // serial_conf: portData.serial_conf,
      serial_parity: portData.serial_parity,
      serial_data_bit: portData.serial_data_bit,
      serial_stop_bit: portData.serial_stop_bit,
      modbus_slaves: portData.modbus_slaves,
      hmis: portData.hmis,
    }),

    // sorted by port name array
    ports: isModbusDevice
      ? portData.ports || []
      : portData.ports
          .sort((a, b) => a.port_name.localeCompare(b.port_name))
          .map((port) => {
            port.port_name = port.port_name.toLowerCase();
            return {
              port_nickname: port.port_desc || port.port_name.toUpperCase(),
              port_id: port.port_id,
              port_name: port.port_name,
              port_type: port.port_type,
              port_desc: port.port_desc,
              ui_display: port.ui_display,
              ui_widget: port.ui_widget,
              ui_color: port.ui_color,
              display_min: port.display_min,
              display_max: port.display_max,
              port_min: port.port_min,
              port_max: port.port_max,
              unit: port.unit,
              dec_place: port.dec_place,
              ai_mode: port.ai_mode,
              count_type: port.count_type,
              count_dir: port.count_dir,
              events: port.events,
              commands: port.commands,
              schedules: port.schedules,
              safe_mode: port.safe_mode,
              relay_mode: port.relay_mode,
              valid_time: port.valid_time,
              count_def: port.count_def,
            };
          }),
  };
}

export function getServiceType(type) {
  const service = SERVICE_TYPE.find((el) => el.value === parseInt(type));
  return service ? service.label : '';
}

export function viewListFormatted(rawList) {
  const viewList = rawList.slice();
  viewList.forEach((view) => {
    view.view_config =
      typeof view.view_config === 'string'
        ? parseJSON(view.view_config)
        : view.view_config;
    // view.update_time = view.update_time;
  });
  return viewList.map(
    ({ view_config, view_name, update_time, view_id, owner, share_id }) => ({
      view_config,
      view_name,
      update_time,
      view_id,
      owner,
      share_id,
    })
  );
}

export function viewDataFormatted(rawData) {
  const viewData = Object.assign({}, rawData);
  viewData.view_config =
    typeof viewData.view_config === 'string'
      ? parseJSON(viewData.view_config)
      : viewData.view_config;
  // viewData.update_time = viewData.update_time;
  if (viewData.pages) {
    viewData.pages.forEach((page) => {
      page.page_config =
        typeof page.page_config === 'string'
          ? parseJSON(page.page_config)
          : page.page_config;
      page.page_image = page.page_image ? decodeURI(page.page_image) : null;
      page.items.forEach((item) => {
        item.item_config =
          typeof item.item_config === 'string'
            ? parseJSON(item.item_config)
            : item.item_config;
      });
    });
  }
  const { view_config, view_name, update_time, pages, view_id } = viewData;
  return { view_config, view_name, update_time, pages, view_id };
}

export function viewPageFormatted(rawData) {
  const pageData = Object.assign({}, rawData);
  const arrayPage = Array.isArray(pageData) ? pageData : [pageData];
  arrayPage.forEach((page) => {
    page.page_config =
      typeof page.page_config === 'string'
        ? parseJSON(page.page_config)
        : page.page_config;
    page.page_image = page.page_image ? decodeURI(page.page_image) : null;
  });
  return arrayPage.map(({ page_config, page_id, page_image, items }) => ({
    page_config,
    page_image,
    page_id,
    items,
  }));
}

export function viewItemFormatted(rawData) {
  const itemData = Object.assign({}, rawData);
  const arrayItem = Array.isArray(itemData) ? itemData : [itemData];
  arrayItem.forEach((item) => {
    item.item_config =
      typeof item.item_config === 'string'
        ? parseJSON(item.item_config)
        : item.item_config;
  });
  return arrayItem.map(({ item_config, port_id, item_id }) => ({
    item_config,
    port_id,
    item_id,
  }));
}

export function portDetailFormatted({
  port_id,
  port_name,
  port_type,
  port_desc,
  port_min,
  port_max,
  ai_mode,
  unit,
  display_min,
  display_max,
  dev_id,
  dev_model,
  topic_connection_state,
  topic_data_request,
  topic_data_report,
  topic_data_control_web,
  relay_mode,
  count_dir,
  mac_addr,
  dec_place,
  commands,
}) {
  return {
    port_id,
    port_name,
    port_type,
    port_desc,
    port_min,
    port_max,
    ai_mode,
    unit,
    dec_place,
    display_min,
    display_max,
    dev_id,
    dev_model,
    topic_connection_state,
    topic_data_request,
    topic_data_report,
    topic_data_control_web,
    relay_mode,
    count_dir,
    mac_addr,
    commands,
  };
}

export function modbusSlaveFormatted({
  port_id,
  port_type,
  query_type,
  slave_desc,
  slave_addr,
  req_func,
  req_addr,
  hmi_addr,
  port_id_dec,
  slave_enabled,
  modbus_frame_on,
  modbus_frame_off,
  // req_quantity,
  // req_bcount,
  // req_data,
  widget,
  rep_scale,
  rep_offset,
  byte_swap,
  word_swap,
  dword_swap,
  port_offset,
  port_quantity,
  data_type,
  modbus_timeout,
  modbus_interframe_gap,
  max_query,
  dec_place,
  events,
  topic_connection_state,
  topic_data_request,
  topic_data_report,
  topic_data_control_web,
  dev_model,
  mac_addr,
  dev_id,
}) {
  const slaveUIData =
    typeof widget === 'string' ? JSON.parse(widget || '{}') : widget || {};
  const byteNum = getByteCountFromDataType(data_type || DATATYPE.INT32);
  const uiPortType = query_type
    ? mapModbusPortType(query_type || port_type, req_func, hmi_addr)
    : ANALOG_INPUT;
  const queryType = query_type || port_type || 'MB';
  const slave_events = setDefaultValue(events, []);

  slave_events.forEach((evt) => {
    if (!evt.ctrl_actions) evt.ctrl_actions = []; // Test command actions
  });
  const displayMin = setDefaultValue(slaveUIData.display_min, 0);
  const displayMax = setDefaultValue(slaveUIData.display_max, 100);
  const uiDisplay = setDefaultValue(slaveUIData.ui_display, 1);
  const uiWidget = getDefaultModbusWidget(uiPortType, slaveUIData.ui_widget);
  const uiColor = setDefaultValue(slaveUIData.ui_color, COLOR_LIST[0]);
  const uiUnit = setDefaultValue(slaveUIData.unit, '');
  const relayMode = setDefaultValue(slaveUIData.relay_mode, 0);
  let reqFunc = typeof req_func === 'number' ? req_func : REQ_FUNC.FC03;
  const reqAddr = typeof req_addr === 'number' ? req_addr : 0;
  if (queryType === 'HMI' && hmi_addr) {
    reqFunc = FC_MAP[hmi_addr.substring(0, 1)] || REQ_FUNC.FC03;
  }

  return {
    port_id,
    port_id_dec,
    ...(dev_id && {
      dev_id,
    }),
    port_type: uiPortType,
    query_type: queryType,
    port_name: uiPortType,
    ...(typeof dev_model === 'string' && {
      dev_model,
    }),
    ...(typeof mac_addr === 'string' && {
      mac_addr,
    }),
    slave_desc: slave_desc || '',
    slave_addr: setDefaultValue(slave_addr, 1),
    slave_enabled: Boolean(slave_enabled),
    is_modbus: true,
    req_func: reqFunc,
    req_addr: reqAddr,
    hmi_addr: typeof hmi_addr === 'string' ? hmi_addr || '0' : '30001',
    req_quantity: Math.ceil(byteNum / 2),
    req_bcount: byteNum,
    // req_data: req_data || '',
    topic_connection_state,
    rep_scale: setDefaultValue(rep_scale, 1),
    rep_offset: setDefaultValue(rep_offset, 0),
    events: slave_events,
    byte_swap: Boolean(byte_swap),
    word_swap: Boolean(word_swap),
    dword_swap: Boolean(dword_swap),
    port_offset: setDefaultValue(port_offset, 0),
    port_quantity: setDefaultValue(port_quantity, 1),
    data_type: data_type || DATATYPE.INT16,
    modbus_frame_on,
    modbus_frame_off,
    topic_data_request,
    topic_data_report,
    topic_data_control_web,
    ...(typeof modbus_timeout === 'number' && {
      modbus_timeout,
    }),
    modbus_interframe_gap: setDefaultValue(modbus_interframe_gap, 0),
    max_query: setDefaultValue(max_query, MAX_QUERIES),
    display_min: displayMin,
    display_max: displayMax,
    ui_widget: uiWidget,
    ui_color: uiColor,
    ui_display: uiDisplay,
    unit: uiUnit,
    dec_place: setDefaultValue(dec_place, 1),
    relay_mode: relayMode,
    widget: {
      display_min: displayMin,
      display_max: displayMax,
      ui_widget: uiWidget,
      ui_color: uiColor,
      ui_display: uiDisplay,
      unit: uiUnit,
      relay_mode: relayMode,
    },
  };
}

export function getDefaultModbusWidget(ui_port_type, current_ui_widget) {
  switch (ui_port_type) {
    case DIGITAL_INPUT:
      return [WGT_DI_DLED, WGT_DI_CHART].indexOf(current_ui_widget) === -1
        ? WGT_DI_DLED
        : current_ui_widget;
    case DIGITAL_OUTPUT:
      return [WGT_DO_PLED, WGT_DO_CHART].indexOf(current_ui_widget) === -1
        ? WGT_DO_PLED
        : current_ui_widget;
    default:
    case ANALOG_INPUT:
      return [
        WGT_AI_TEXT,
        WGT_AI_GAUGE,
        WGT_AI_THERMO,
        WGT_AI_DROPLET,
        WGT_AI_HBAR,
        WGT_AI_VBAR,
        WGT_AI_CBAR,
        WGT_AI_CHART,
      ].indexOf(current_ui_widget) === -1
        ? WGT_AI_GAUGE
        : current_ui_widget;
  }
}

export function modbusDataFormatted(modbusData) {
  // console.log(JSON.stringify(portData))
  modbusData.dev_nickname = setDefaultValue(
    modbusData.dev_desc || modbusData.mac_addr,
    ''
  );
  modbusData.dev_desc = setDefaultValue(modbusData.dev_desc, '');
  modbusData.add_date = setDefaultValue(modbusData.add_date || '');
  modbusData.cert_issuer_cn = setDefaultValue(modbusData.cert_issuer_cn, '');
  modbusData.cert_root_cn = setDefaultValue(modbusData.cert_root_cn, '');
  modbusData.dev_pkg = setDefaultValue(modbusData.dev_pkg, '');
  modbusData.dev_service = setDefaultValue(modbusData.dev_service, 0);

  modbusData.modbus_timeout = setDefaultValue(modbusData.modbus_timeout, 500);
  modbusData.modbus_interframe_gap = setDefaultValue(
    modbusData.modbus_interframe_gap,
    0
  );
  modbusData.max_query = setDefaultValue(modbusData.max_query, MAX_QUERIES);
  modbusData.serial_type = setDefaultValue(modbusData.serial_type, 'ANY');
  modbusData.serial_baudrate = parseInt(modbusData.serial_baudrate);
  modbusData.serial_parity = parseInt(modbusData.serial_parity);
  modbusData.serial_data_bit = parseInt(modbusData.serial_data_bit);
  modbusData.serial_stop_bit = parseInt(modbusData.serial_stop_bit);

  if (!modbusData.modbus_slaves) modbusData.modbus_slaves = [];
  if (!modbusData.hmis) modbusData.hmis = [];
  modbusData.ports = [...modbusData.modbus_slaves, ...modbusData.hmis].sort(
    (a, b) => a.port_id_dec - b.port_id_dec
  );
  modbusData.ports
    // .sort((a, b) => a.port_name.localeCompare(b.port_name))
    .forEach((slave) => {
      const uiPortType = mapModbusPortType(
        slave.query_type || slave.port_type,
        slave.req_func,
        slave.hmi_addr
      );
      slave.query_type = slave.query_type || slave.port_type;
      slave.port_type = uiPortType;
      slave.port_name = uiPortType;
      // slave.port_nickname = slave.port_desc || slave.port_name.toUpperCase();
      // slave.port_name = slave.port_name.toLowerCase();
      slave.slave_desc = setDefaultValue(slave.slave_desc, '');
      slave.byte_swap = Boolean(slave.byte_swap);
      slave.word_swap = Boolean(slave.word_swap);
      slave.dword_swap = Boolean(slave.dword_swap);
      slave.port_offset = setDefaultValue(slave.port_offset, 0);
      slave.port_quantity = setDefaultValue(slave.port_quantity, 1);
      slave.rep_scale = setDefaultValue(slave.rep_scale, 1);
      slave.rep_offset = setDefaultValue(slave.rep_offset, 0);
      slave.data_type = setDefaultValue(slave.data_type, DATATYPE.INT16);
      slave.slave_addr = setDefaultValue(slave.slave_addr, 1);
      slave.slave_enabled = Boolean(slave.slave_enabled);
      slave.is_modbus = true;
      slave.req_func =
        slave.query_type === 'MB' || !slave.hmi_addr
          ? slave.req_func || REQ_FUNC.FC03
          : FC_MAP[slave.hmi_addr.substring(0, 1)] || REQ_FUNC.FC03;
      slave.req_addr = setDefaultValue(slave.req_addr, 0);
      slave.dec_place = setDefaultValue(slave.dec_place, 1);

      slave.hmi_addr = setDefaultValue(slave.hmi_addr, '30001');
      const byteNum = getByteCountFromDataType(
        slave.data_type || DATATYPE.INT16
      );

      slave.req_quantity = Math.ceil(byteNum / 2);
      slave.req_bcount = byteNum;
      slave.events = setDefaultValue(slave.events, []);

      slave.events.forEach((evt) => {
        if (!evt.ctrl_actions) evt.ctrl_actions = []; // Test command actions
      });
      const slaveUIData =
        typeof slave.widget === 'string'
          ? JSON.parse(slave.widget || '{}')
          : slave.widget || {};

      const displayMin = setDefaultValue(slaveUIData.display_min, 0);
      const displayMax = setDefaultValue(slaveUIData.display_max, 100);
      const uiWidget = getDefaultModbusWidget(
        slave.port_type,
        slaveUIData.ui_widget
      );
      const uiColor = setDefaultValue(slaveUIData.ui_color, COLOR_LIST[0]);
      const uiDisplay = setDefaultValue(slaveUIData.ui_display, 1);
      const uiUnit = setDefaultValue(slaveUIData.unit, '');
      const relayMode = setDefaultValue(slaveUIData.relay_mode, 0);

      slave.display_min = displayMin;
      slave.display_max = displayMax;

      slave.ui_widget = uiWidget;
      slave.ui_color = uiColor;
      slave.ui_display = uiDisplay;
      slave.unit = uiUnit;
      slave.relay_mode = relayMode;
      slave.widget = {
        display_min: displayMin,
        display_max: displayMax,
        ui_widget: uiWidget,
        ui_color: uiColor,
        ui_display: uiDisplay,
        relay_mode: relayMode,
        unit: uiUnit,
      };
    });
  // delete modbusData.hmis;
  // delete modbusData.modbus_slaves;
  return modbusData;
}

export function portDataFormatted(portData) {
  portData.dev_nickname = setDefaultValue(
    portData.dev_desc || portData.mac_addr,
    ''
  );
  portData.dev_desc = setDefaultValue(portData.dev_desc, '');
  portData.add_date = setDefaultValue(portData.add_date || '');
  portData.cert_issuer_cn = setDefaultValue(portData.cert_issuer_cn, '');
  portData.cert_root_cn = setDefaultValue(portData.cert_root_cn, '');
  portData.dev_pkg = setDefaultValue(portData.dev_pkg, '');
  portData.dev_service = setDefaultValue(portData.dev_service, 0);

  if (!portData.ports) portData.ports = [];
  portData.ports
    .sort((a, b) => a.port_name.localeCompare(b.port_name))
    .forEach((port) => {
      port.port_nickname = port.port_desc || port.port_name.toUpperCase();
      port.port_name = port.port_name.toLowerCase();
      port.port_desc = setDefaultValue(port.port_desc, '');
      port.ui_display = setDefaultValue(port.ui_display, 1);
      port.ui_color = setDefaultValue(port.ui_color, COLOR_LIST[0]);
      port.events = setDefaultValue(port.events, []);

      port.events.forEach((evt) => {
        if (!evt.ctrl_actions) evt.ctrl_actions = []; // Test command actions
      });

      switch (port.port_type) {
        case DIGITAL_INPUT:
          port.ui_widget =
            [WGT_DI_DLED, WGT_DI_COUNTER, WGT_DI_CHART].indexOf(
              port.ui_widget
            ) === -1
              ? WGT_DI_DLED
              : port.ui_widget;
          port.count_type = setDefaultValue(port.count_type, 1);
          port.count_dir = setDefaultValue(port.count_dir, 1);
          port.valid_time = parseInt(port.valid_time);
          port.count_def = parseInt(port.count_def || 0);
          break;
        case DIGITAL_OUTPUT:
          port.ui_widget =
            [WGT_DO_PLED, WGT_DO_SCHL, WGT_DO_CHART].indexOf(port.ui_widget) ===
            -1
              ? WGT_DO_PLED
              : port.ui_widget;
          port.schedules = setDefaultValue(port.schedules, []);
          port.relay_mode = setDefaultValue(port.relay_mode, 0);
          port.safe_mode = parseInt(port.safe_mode);
          port.commands = setDefaultValue(port.commands, [])
            .filter(
              (cmd) =>
                [
                  CMD_OUTPUT_LOW,
                  CMD_OUTPUT_HIGH,
                  CMD_OUTPUT_PULSE,
                  CMD_OUTPUT_TOGGLE,
                ].indexOf(parseInt(cmd[0])) !== -1
            )
            .sort();
          break;
        case ANALOG_INPUT:
          port.ui_widget =
            [
              WGT_AI_TEXT,
              WGT_AI_GAUGE,
              WGT_AI_THERMO,
              WGT_AI_DROPLET,
              WGT_AI_HBAR,
              WGT_AI_VBAR,
              WGT_AI_CBAR,
              WGT_AI_CHART,
            ].indexOf(port.ui_widget) === -1
              ? WGT_AI_GAUGE
              : port.ui_widget;
          port.display_min = setDefaultValue(port.display_min, MIN_ADC);
          port.display_max = setDefaultValue(port.display_max, MAX_ADC);
          port.dec_place = setDefaultValue(port.dec_place, 0);
          port.port_min = setDefaultValue(port.port_min, MIN_ADC);
          port.port_max = setDefaultValue(port.port_max, MAX_ADC);
          port.unit = setDefaultValue(port.unit, '');
          // port.ai_mode = port.ai_mode;
          break;
        case TEMPERATURE:
          port.ui_widget =
            [
              WGT_AI_TEXT,
              WGT_AI_GAUGE,
              WGT_AI_THERMO,
              WGT_AI_7SEG,
              WGT_AI_HBAR,
              WGT_AI_VBAR,
              WGT_AI_CBAR,
              WGT_AI_CHART,
            ].indexOf(port.ui_widget) === -1
              ? WGT_AI_THERMO
              : port.ui_widget;
          port.display_min = setDefaultValue(port.display_min, MIN_ADC);
          port.display_max = setDefaultValue(port.display_max, MAX_TEMPERATURE);
          port.dec_place = setDefaultValue(port.dec_place, SIG_5561_DEC_PLACE);
          port.unit = setDefaultValue(port.unit, TEMPO_CELCIUS);
          break;
      }
    });
  // console.log(portData)
  // console.log(JSON.stringify(portData))
  return portData;
}

export function getSingleDevFormatted(dev) {
  return {
    dev_id: dev.dev_id,
    dev_client_id: dev.dev_client_id,
    dev_desc: dev.dev_desc || '',
    mac_addr: dev.mac_addr || '',
    add_date: dev.add_date || '',
    dev_model: dev.dev_model || '',
    dev_nickname: dev.dev_desc || dev.mac_addr || '',
  };
}
export function deviceDataFormatted(deviceData) {
  if (!deviceData) throw new Error('REQUEST FAILED!');
  if (Array.isArray(deviceData)) {
    return deviceData.map(getSingleDevFormatted);
  }
}

export function getTheme(isMobile, fullTheme, nextTheme) {
  return isMobile
    ? (fullTheme & 0xff) | ((nextTheme << 8) & 0xff00)
    : (fullTheme & 0xff00) | (nextTheme & 0xff);
}

export function getOutputBit(hexData, offset) {
  // Convert hex data to binary string
  const binaryString = parseInt(hexData, 16)
    .toString(2)
    .padStart(hexData.length * 4, '0');

  // Find the byte index and bit offset within the byte
  const byteIndex = Math.floor(offset / 8);
  const bitOffset = 7 - (offset % 8);

  // Check the status of the specified bit
  const bitValue = binaryString.charAt(byteIndex * 8 + bitOffset) === '1';

  return bitValue;
}

function getByteValue(original, pos) {
  return (original >> (pos * 8)) & 0xff;
}

export function userDataFormatted(userData) {
  const {
    name,
    email,
    picture,
    timezone_offset,
    language,
    theme,
    /* google_scope, */ user_preferences,
    sound_id,
    max_connections,
    data_storage,
    system_time,
    topic_download_notification,
  } = userData;
  const desktop_theme = getByteValue(theme, DESKTOP_THEME_BYTEPOS);
  const mobile_theme = getByteValue(theme, MOBILE_THEME_BYTEPOS);
  return {
    userName: name,
    userEmail: email,
    profilePic: picture,
    dataStorage: Number(data_storage),
    systemTime: new Date(system_time || 0).getTime(),
    timezoneOffset: parseInt(timezone_offset),
    // googleScope: setDefaultValue(google_scope, []),
    language: LANGLIST.find((lang) => lang.value === language)
      ? language
      : LANGLIST[0].value,
    mobileTheme: THEMELIST.find((th) => th.value === mobile_theme)
      ? mobile_theme
      : THEMELIST[0].value,
    desktopTheme: THEMELIST.find((th) => th.value === desktop_theme)
      ? desktop_theme
      : THEMELIST[0].value,
    theme: theme,
    // langUrl: LANGLIST.map(lang => ({ locale: lang.value, link: userData['base_url_' + lang.value] })),
    maxConn: max_connections,
    userPreferences: Number(user_preferences || 0),
    soundId: Number(sound_id || 0),
    downloadTopic: topic_download_notification?.replace(/\\/g, ''),
  };
}

export function mqttInfoFormatted(mqttInfo) {
  const {
    protocol,
    hostname,
    client_id,
    max_connections,
    onConnectCallback,
    onConnectionLostCallback,
    onMessageArrivedCallback,
    onFailureCallback,
  } = mqttInfo;

  return {
    protocol,
    hostName: hostname,
    webClientID: client_id,
    max_conn: max_connections,
    onConnectCallback,
    onConnectionLostCallback,
    onMessageArrivedCallback,
    onFailureCallback,
  };
}

export function mqttTopicFormatted(deviceData) {
  const {
    topic_connection_state,
    topic_data_report,
    topic_data_request,
    topic_data_control_web,
    topic_config_update,
    topic_pkgware_control,
    topic_notice_report,
    mac_addr,
    dev_client_id,
    dev_id,
    dev_model,
    modbus_timeout,
  } = deviceData;

  return {
    mac_addr,
    dev_client_id,
    dev_id,
    dev_model,

    stateTopic: topic_connection_state?.replace(/\\/g, ''),
    readTopic: topic_data_report?.replace(/\\/g, ''),
    reqTopic: topic_data_request?.replace(/\\/g, ''),
    writeTopic: topic_data_control_web?.replace(/\\/g, ''),

    writeFirmwareTopic: topic_pkgware_control?.replace(/\\/g, ''),
    updateConfigTopic: topic_config_update?.replace(/\\/g, ''),
    resDeviceTopic: topic_notice_report?.replace(/\\/g, ''),

    modbus_timeout,
  };
}

export function parseJSON(json) {
  try {
    return JSON.parse(json);
  } catch (e) {
    return new Error(ERR_INVALID_JSON);
  }
}
export const GEN_ID_PREFIX = 'temp-id-';

export function generateUniqueID() {
  return (
    GEN_ID_PREFIX +
    Math.round(Math.random() * 1000).toString(16) +
    new Date().getTime().toString(16)
  );
}

export function isModbusGateway(dev_model = '') {
  return dev_model.toLowerCase().startsWith('smg');
}

export function setDefaultValue(param, defVal) {
  if (typeof param === 'object') {
    if (param != null && Object.keys(param).length) return param;
  } else {
    if (typeof param === 'number') {
      if (!isNaN(param) && isFinite(param)) return param;
    } else if (isStr(param)) return param;
  }
  return defVal;
}

export function roundedValue(src, dec_place, keep_length) {
  const pow = Math.pow(10, dec_place);
  const ret = Math.round(parseFloat(src) * pow) / pow;
  return keep_length ? ret.toFixed(dec_place) : ret;
}

export function toFloatNumber(value, decimal) {
  const decPlace = decimal >= 0 ? decimal : 2;
  return parseFloat(parseFloat(value).toFixed(decPlace));
}

export function getMidnightTimestamp(timestamp, timezoneOffset) {
  // Convert the timestamp to a Date object
  const date = new Date(timestamp);

  // Reset the time to midnight in the local timezone
  date.setHours(0, 0, 0, 0);

  // Calculate the offset difference
  const currentOffset = date.getTimezoneOffset(); // Local timezone offset in minutes
  const offsetDiff = timezoneOffset - currentOffset;
  // Calculate the adjusted midnight timestamp
  const adjustedTimestamp = date.getTime() + offsetDiff * 60 * 1000;

  const dailyTimeDiff = 24 * 60 * 60 * 1000;
  if (timestamp < adjustedTimestamp) {
    return adjustedTimestamp - dailyTimeDiff;
  }

  if (timestamp > adjustedTimestamp + dailyTimeDiff) {
    return adjustedTimestamp + dailyTimeDiff;
  }

  return adjustedTimestamp;
}

export function getParticularTimestamp(timestamp, timezoneOffset, options) {
  if (isNaN(timestamp)) return timestamp;
  const date = new Date(Number(timestamp) * 1000);
  const localTimezone = date.getTimezoneOffset();
  const timeZone = timezoneOffset == null ? localTimezone : timezoneOffset;

  const utc = date.getTime() + localTimezone * 60000;
  var newDate = new Date(utc - 60000 * timeZone);
  return (
    MONTH_LIST[newDate.getMonth()] +
    ' ' +
    getTwoDigitString(newDate.getDate()) +
    ', ' +
    newDate.getFullYear() +
    (options?.removeTimestring
      ? ''
      : ', ' +
        getTwoDigitString(newDate.getHours()) +
        ':' +
        getTwoDigitString(newDate.getMinutes()) +
        ':' +
        getTwoDigitString(newDate.getSeconds()) +
        (options?.removeTimezone ? '' : ' (' + getStringOffset(timeZone) + ')'))
  );
}

export function getDateTimeStr(timestamp) {
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  const formattedDateTimeString = `${year}${month}${day}${hours}${minutes}${seconds}`;

  return formattedDateTimeString;
}

export function getParticularDateString(timestamp, timezoneOffset, isRaw) {
  if (isNaN(timestamp)) return timestamp;
  const date = new Date(Number(timestamp));
  const localTimezone = date.getTimezoneOffset();
  const timeZone = timezoneOffset == null ? localTimezone : timezoneOffset;

  const utc = date.getTime() + localTimezone * 60000;
  var newDate = new Date(utc - 60000 * timeZone);
  // const timezoneString = getStringOffset(timeZone);
  return (
    newDate.getFullYear() +
    '-' +
    getTwoDigitString(newDate.getMonth() + 1) +
    '-' +
    getTwoDigitString(newDate.getDate()) /* +
    (isRaw ? timezoneString.replace(/[+\-:]/g, '') : '') */
  );
}

export function getTwoDigitString(str) {
  return ('00' + str).slice(-2);
}

export function getTimespan(minTime, maxTime) {
  const dateA = new Date(minTime);
  const dateB = new Date(maxTime);

  const hourDifference = Math.abs(dateA - dateB) / 3600000;
  if (hourDifference < 1) {
    const minuteDifference = Math.round(hourDifference * 60);
    return minuteDifference * 60000;
  } else {
    const decimalPart = hourDifference % 1;
    const roundedHourDifference =
      decimalPart > 0.96
        ? Math.ceil(hourDifference)
        : Math.floor(hourDifference);
    return roundedHourDifference * 3600000;
  }
}

export function getTimeDurationString(timeDifferenceMillisec) {
  const minutes = Math.round(timeDifferenceMillisec / 60000);

  if (minutes < 60) {
    return `${minutes}m`;
  } else {
    const hours = Math.round(minutes / 60);
    return `${hours}h`;
  }
}

export function parseCSV(csvString) {
  const lines = csvString.split('\n').filter((line) => line.trim() !== '');
  const headers = lines[0].split(',');

  return lines.slice(1).map((line) => {
    const currentLine = line.split(',');
    return headers.reduce((obj, header, index) => {
      const hd = (header || '').trim();
      obj[hd] = (currentLine[index] || '').trim();
      return obj;
    }, {});
  });
}

export function getStringOffset(timezone) {
  return (
    'UTC' +
    (timezone <= 0 ? '+' : '-') +
    getTwoDigitString(Math.floor(Math.abs(timezone / 60))) +
    ':' +
    getTwoDigitString(timezone % 60)
  );
}

export function getBoolean(input) {
  return Boolean(Number(input));
}

export function sortDevices(a, b, type) {
  const sortType = SORT_BY.map((t) => t.value);
  switch (type) {
    case sortType[1]:
      return (a.add_date + '').localeCompare(b.add_date + '');
    case sortType[2]:
      return a.dev_desc.localeCompare(b.dev_desc);
    case sortType[3]:
      return b.dev_desc.localeCompare(a.dev_desc);
    case sortType[4]:
      return a.dev_model.localeCompare(b.dev_model);
    case sortType[5]:
      return b.dev_model.localeCompare(a.dev_model);
    case sortType[0]:
    default:
      return (b.add_date + '').localeCompare(a.add_date + '');
  }
}

export function sortDevicesByAttribute(a, b, attr, isDescendent) {
  if (b[attr] == null || a[attr] == null) return 0;
  return isDescendent
    ? a[attr].toString().localeCompare(b[attr].toString())
    : b[attr].toString().localeCompare(a[attr].toString());
}

export function getChangeOwnershipQuery(client_id) {
  return { dev_client_id: client_id };
}

export function matchWildCardTopic(topic, wildcardPattern) {
  const patternRegex = new RegExp(
    '^' + wildcardPattern.replace(/\+/g, '[^/]+').replace(/#/g, '.+') + '$'
  );

  return patternRegex.test(topic);
}

export function extractHTTPInfo(payload) {
  const httpRes = payload.split('\n\n');
  const bodyRes = parseJSON(httpRes.slice(1).join(''));
  const httpHeaders = (httpRes[0] || '').split('\n');
  const httpStatus = parseInt(httpHeaders[0].split(' ')[1]);
  const requestedURL = httpHeaders
    .find((header) => header.indexOf(process.env.SOLLAE_REQUEST_URL) !== -1)
    .split('/');
  const clientIDHeader = httpHeaders.find(
    (header) => header.indexOf(process.env.SOLLAE_REQUEST_CLIENT_ID) !== -1
  );

  const methodHeader = httpHeaders
    .find((header) => header.indexOf(process.env.SOLLAE_REQUEST_METHOD) !== -1)
    .split(' ')[1];

  return {
    status: isNaN(httpStatus) ? 'UNKNOWN_SERVER_RESPONSE' : httpStatus,
    body: isStr(bodyRes) ? null : bodyRes,
    dev_id:
      requestedURL.indexOf('devices') !== -1
        ? requestedURL[requestedURL.indexOf('devices') + 1]
        : null,
    client_id: clientIDHeader ? clientIDHeader.split(' ').pop() : null,
    method: methodHeader,
  };
}

export function findDeviceId(jsonRes, portsData) {
  try {
    const res = jsonRes.map((json) => json.relative_url);
    for (let i = 0; i < res.length; i++) {
      const urlParams = res[i].split('/');
      const devIndex = urlParams.indexOf('devices');
      if (devIndex !== -1) return urlParams[devIndex + 2];
      const portIndex = urlParams.indexOf('ports');
      if (portIndex !== -1) {
        const port_id = urlParams[portIndex + 2];
        const deviceByPortId = portsData.find((dev) =>
          dev.ports.find((p) => p.port_id === port_id)
        );
        if (deviceByPortId) return deviceByPortId.dev_id;
      }
      const eventIndex = urlParams.indexOf('events');
      if (eventIndex !== -1) {
        const event_id = urlParams[eventIndex + 1];
        const deviceByEventId = portsData.find((dev) =>
          dev.ports.find(
            (p) => p.events && p.events.find((ev) => ev.event_id === event_id)
          )
        );

        if (deviceByEventId) return deviceByEventId.dev_id;
      }
    }
  } catch (err) {
    Logger.error(err);
  }
}

export function findErrorCode(jsonRes) {
  try {
    const response =
      typeof jsonRes === 'string' ? JSON.parse(jsonRes) : jsonRes;
    if (response && response.error) {
      return response.error.code || response.error.status;
    }
    const res = response.find((json) => json.body && json.body.error);
    if (res) return res.body.error.code || res.body.error.status;
  } catch (err) {
    Logger.error(err);
  }
}

export function validateValue(value) {
  return typeof value === 'boolean' || (value !== null && !isNaN(value));
}

export function createDebounce(func, wait) {
  let timeoutId = null;

  const debounced = function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      timeoutId = null;
      func.apply(this, args);
    }, wait);
  };

  debounced.cancel = function () {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  return debounced;
}
